const _ = {
  tiles: document.querySelectorAll('.c-Tile'),
}

function setDrawerHeight(drawer, opening) {
  const inner = drawer.querySelector('.c-Tile__drawer-inner')
  const outer = drawer.querySelector('.c-Tile__drawer-outer')
  const innerHeight = inner.getBoundingClientRect().height

  if (opening) {
    outer.style.height = `${innerHeight}px`
  } else {
    outer.style.height = `${0}px`
  }
}

function openDrawer(drawer, button) {
  const thisButton = button
  thisButton.innerHTML = 'Close'
  drawer.classList.add('is-open')
  setDrawerHeight(drawer, true)
}

function closeDrawer(drawer, button) {
  const thisButton = button
  thisButton.innerHTML = 'Info'
  drawer.classList.remove('is-open')
  setDrawerHeight(drawer, false)
}

function toggleDrawer(e) {
  const button = e.currentTarget
  const drawer = e.currentTarget.parentNode
  const action = drawer.classList.contains('is-open')
    ? closeDrawer(drawer, button)
    : openDrawer(drawer, button)

  return action
}

const enable = () => {
  if (_.tiles.length) {
    const tiles = Array.from(_.tiles)

    tiles.forEach((tile) => {
      const button = tile.querySelector('.c-Tile__drawer-switch')
      button.addEventListener('click', toggleDrawer)
    })
  }
}

export default { enable }
